const state = {
  lines: [
    {
      code: "west",
      title: "Metro West"
    },
    {
      code: "greaterWest",
      title: "Greater West"
    },
    {
      code: "northWest",
      title: "NorthWest"
    },
    {
      code: "citySouthWest",
      title: "City and SouthWest"
    },
    {
      code: "futureProjects",
      title: "Future Projects"
    }
  ],
  stations: {
    west: [
      "Example Station X",
      "Pyrmont",
      "The Bays Precinct",
      "Five Dock",
      "Burwood North",
      "North Strathfield",
      "Olympic Park",
      "Silverwater",
      "Clyde",
      "Parramatta",
      "Westmead"
    ],
    greaterWest: [],
    northWest: [],
    citySouthWest: [],
    futureProjects: []
  },
  selectedLine: {},
  selectedStations: [],
  zones: [
    {
      code: "commercial",
      title: "Commercial",
      icon: "img/icons/projectIcon/commercial_icon.png",
      path: "/commercial"
    },
    {
      code: "reporting",
      title: "Reporting",
      icon: "img/icons/projectIcon/report_icon.png",
      path: "/reporting"
    },
    {
      code: "design",
      title: "Design",
      icon: "img/icons/projectIcon/design_icon.png",
      path: "/design"
    },
    {
      code: "collaboration",
      title: "Collaboration",
      icon: "img/icons/projectIcon/collab_icon.png",
      path: "/collaboration"
    },
    {
      code: "management",
      title: "Management",
      icon: "img/icons/projectIcon/management_icon.png",
      path: "/management"
    },
    {
      code: "virtualreality",
      title: "Virtual Reality",
      icon: "img/icons/projectIcon/innovation_icon.png",
      path: "/virtualreality"
    },
    // {
    //   code: "innovation",
    //   title: "Research and Innovation",
    //   icon: "img/icons/projectIcon/innovation_icon.png",
    //   path: "/innovation"
    // },
  ],
  categories: {
    commercial: [
      "Cost (Capex)",
      "Cost (Opex)",
      "Procurement and Supply Chain",
      "Contract"
    ],
    reporting: [
      "Monthly",
      "Weekly",
      "Live"
    ],
    design: [
      "Requirements",
      "Resourcing",
      "Design",
      "Construction",
      "Reporting and Analytics"
    ],
    collaboration: [
      "Correspondence Management",
      "File Transfer",
      "Contact List",
      "Meetings",
      "Action Lists",
      "Risk and Issue Management",
      "Document Management",
      "Shared Calendar",
      "Interface Management",
      "Stakeholder Management"
    ],
    management: [
      "Management Plans",
      "Passport (Inductions)",
      "Resource Management",
      "Planning and Scheduling",
      "Change Control",
      "Health and Safety"
    ],
    virtualreality: [
      "Virtual Reality"
    ]
    // innovation: [
    //   "Innovation"
    // ]
  },
  selectedZone: {},
  selectedCategories: [],
  counter: 0,
  activeTabFlags: {
    insightSection: false,
    bim360Section: false,
    GISDashboardSection: false,
    GISPortalSection: false,
    simulationSection: false,
    opsSection: false,
    teamBinderSection: false
  },
  portfolios: [
    {
      code: "portfolio",
      title: "Portfolio"
    }
    // {
    //   code: "passenger_service",
    //   title: "Passenger Services"
    // },
    // {
    //   code: "other_lines",
    //   title: "Other Lines"
    // },
    // {
    //   code: "closed_lines",
    //   title: "Closed Lines"
    // },

  ],
  projects: {
    portfolio: [
      "MID"
      // "Tottenham to Albury (T2A)",
      // "Albury to Illabo (A2I)",
      // "Illabo to Stockinbingal (I2S)",
      // "Stockinbingal to Parkes (S2P)",
      // "Parkes to Narromine (P2N)",
      // "Narromine to Narrabri (N2N)",
      // "Narrabri to North Star (N2NS)",
      // "North Star to Border (NS2B)",
      // "Border to Gowrie (B2G)",
      // "Gowrie to Helidon (G2H)",
      // "Helidon to Calvert (H2C)",
      // "Calvert to Kaguru (C2K)",
      // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
    ]
    // passenger_service: [
    //   "Muswellbrook",
    //   "Station A",
    //   "Station B",
    //   "Station C",
    //   "Station D"
    // ],
    // other_lines: [
    //   "Station E",
    //   "Station F",
    //   "Station G",
    //   "Station H",
    //   "Station I"
    // ],
    // closed_lines: [
    //   "Station J",
    //   "Station K",
    //   "Station L",
    //   "Station M",
    //   "Station N"
    // ]
  },
  projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        }
      ]
    },
    {
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "virtualreality",
      items: [
        {
          category: "Virtual Reality",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        }
      ]
    }
  ],
  selectedPortfolio: {},
  selectedProjects: [],
  currentSelectedProject: "",
  currentSelectedSubCategory: "",
  currentSelectedProjectTab: {
    category: "",
    tabs: [
    ]
  }
}

function initialState() {
  return {
    lines: [
      {
        code: "west",
        title: "Metro West"
      },
      {
        code: "greaterWest",
        title: "Greater West"
      },
      {
        code: "northWest",
        title: "NorthWest"
      },
      {
        code: "citySouthWest",
        title: "City and SouthWest"
      },
      {
        code: "futureProjects",
        title: "Future Projects"
      }
    ],
    stations: {
      west: [
        "Example Station X",
        "Pyrmont",
        "The Bays Precinct",
        "Five Dock",
        "Burwood North",
        "North Strathfield",
        "Olympic Park",
        "Silverwater",
        "Clyde",
        "Parramatta",
        "Westmead"
      ],
      greaterWest: [],
      northWest: [],
      citySouthWest: [],
      futureProjects: []
    },
    selectedLine: {},
    selectedStations: [],
    zones: [
      {
        code: "commercial",
        title: "Commercial",
        icon: "img/icons/projectIcon/commercial_icon.png",
        path: "/commercial"
      },
      {
        code: "reporting",
        title: "Reporting",
        icon: "img/icons/projectIcon/report_icon.png",
        path: "/reporting"
      },
      {
        code: "design",
        title: "Design",
        icon: "img/icons/projectIcon/design_icon.png",
        path: "/design"
      },
      {
        code: "collaboration",
        title: "Collaboration",
        icon: "img/icons/projectIcon/collab_icon.png",
        path: "/collaboration"
      },
      {
        code: "management",
        title: "Management",
        icon: "img/icons/projectIcon/management_icon.png",
        path: "/management"
      },
      {
        code: "virtualreality",
        title: "Virtual Reality",
        icon: "img/icons/projectIcon/innovation_icon.png",
        path: "/virtualreality"
      },
      // {
      //   code: "innovation",
      //   title: "Research and Innovation",
      //   icon: "img/icons/projectIcon/innovation_icon.png",
      //   path: "/innovation"
      // },
    ],
    categories: {
      commercial: [
        "Cost (Capex)",
        "Cost (Opex)",
        "Procurement and Supply Chain",
        "Contract"
      ],
      reporting: [
        "Monthly",
        "Weekly",
        "Live"
      ],
      design: [
        "Requirements",
        "Resourcing",
        "Design",
        "Construction",
        "Reporting and Analytics"
      ],
      collaboration: [
        "Correspondence Management",
        "File Transfer",
        "Contact List",
        "Meetings",
        "Action Lists",
        "Risk and Issue Management",
        "Document Management",
        "Shared Calendar",
        "Interface Management",
        "Stakeholder Management"
      ],
      management: [
        "Management Plans",
        "Passport (Inductions)",
        "Resource Management",
        "Planning and Scheduling",
        "Change Control",
        "Health and Safety"
      ],
      virtualreality: [
        "Virtual Reality"
      ]
      // innovation: [
      //   "Innovation"
      // ]
    },
    selectedZone: {},
    selectedCategories: [],
    counter: 0,
    activeTabFlags: {
      insightSection: false,
      bim360Section: false,
      GISDashboardSection: false,
      GISPortalSection: false,
      simulationSection: false,
      opsSection: false,
      teamBinderSection: false
    },
    portfolios: [
      {
        code: "portfolio",
        title: "Portfolio"
      }
      // {
      //   code: "passenger_service",
      //   title: "Passenger Services"
      // },
      // {
      //   code: "other_lines",
      //   title: "Other Lines"
      // },
      // {
      //   code: "closed_lines",
      //   title: "Closed Lines"
      // },

    ],
    projects: {
      portfolio: [
        "SRLA"
        // "Tottenham to Albury (T2A)",
        // "Albury to Illabo (A2I)",
        // "Illabo to Stockinbingal (I2S)",
        // "Stockinbingal to Parkes (S2P)",
        // "Parkes to Narromine (P2N)",
        // "Narromine to Narrabri (N2N)",
        // "Narrabri to North Star (N2NS)",
        // "North Star to Border (NS2B)",
        // "Border to Gowrie (B2G)",
        // "Gowrie to Helidon (G2H)",
        // "Helidon to Calvert (H2C)",
        // "Calvert to Kaguru (C2K)",
        // "Kaguru to Acacia Ridge / Bromelton (K2AR)"
      ]
      // passenger_service: [
      //   "Muswellbrook",
      //   "Station A",
      //   "Station B",
      //   "Station C",
      //   "Station D"
      // ],
      // other_lines: [
      //   "Station E",
      //   "Station F",
      //   "Station G",
      //   "Station H",
      //   "Station I"
      // ],
      // closed_lines: [
      //   "Station J",
      //   "Station K",
      //   "Station L",
      //   "Station M",
      //   "Station N"
      // ]
    },
    projectTabs: [
    {
      zoneCode: "commercial",
      items: [
        {
          category: "Cost (Capex)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Cost (Opex)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Procurement and Supply Chain",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Contract",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "reporting",
      items: [
        {
          category: "Monthly",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Weekly",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Live",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "design",
      items: [
        {
          category: "Requirements",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Resourcing",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Design",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Construction",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Reporting and Analytics",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "collaboration",
      items: [
        {
          category: "Correspondence Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "File Transfer",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Contact List",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Meetings",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Action Lists",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Risk and Issue Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Document Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Shared Calendar",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Interface Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Stakeholder Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        }
      ]
    },
    {
      zoneCode: "management",
      items: [
        {
          category: "Management Plans",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Passport (Inductions)",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Resource Management",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Planning and Scheduling",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Change Control",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
        {
          category: "Health and Safety",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        },
      ]
    },
    {
      zoneCode: "virtualreality",
      items: [
        {
          category: "Virtual Reality",
          tabs: [
            {
              title: "3D MODEL",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/3DViewTab.png",
              url: ""
            },
            {
              title: "DATA MANAGEMENT",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/InfoExchangeTab.png",
              url: ""
            },
            {
              title: "TEAMBINDER",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/teamBinderTab.png",
              url: ""
            },
            {
              title: "GIS",
              component2D: true,
              component3D: false,
              imgUrl: "img/assets/tabs/2DViewTab.png",
              url: ""
            },
            {
              title: "DESIGN REVIEW",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/DesignReviewTab.png",
              url: ""
            },
            {
              title: "360 Project View",
              component2D: false,
              component3D: false,
              url: "https://tap5.geodemosolutions.com/"
            },
            {
              title: "REQUIREMENTS",
              component2D: false,
              component3D: false,
              imgUrl: "img/assets/tabs/RequirementsTab.png",
              url: ""
            }
          ]
        }
      ]
    }
  ],
    selectedPortfolio: {},
    selectedProjects: [],
    currentSelectedProject: "",
    currentSelectedSubCategory: "",
    currentSelectedProjectTab: {
      category: "",
      tabs: [
      ]
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {
    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedProject(state, payload) {
    state.currentSelectedProject = payload
  },
  setCurrentSelectedProjectTab(state, payload) {
    state.currentSelectedProjectTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
